module.exports = __webpack_public_path__ + "static/media/image5.e73f65ae.png";